import { useMutation, useQueryClient } from '@tanstack/react-query';
import { duplicateProduct, productsQueryKeys } from '@api/products';
import { toast } from '@/hooks/use-toast';
import { ToastLinkDescription } from '@/components/ui/toast';
import { useTranslation } from '../useTranslation';

export function useDuplicateProduct() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: (id: number) => duplicateProduct(id),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: productsQueryKeys.lists() });
      const product = data.product;
      const { dismiss } = toast({
        description: (
          <ToastLinkDescription
            name={product.name}
            href={`/products/${product.id}/edit`}
            label={t('duplicate.toast.success')}
            onNavigate={() => dismiss()}
          />
        ),
      });
    },
    onError: (error) => {
      toast({
        title: t('duplicate.toast.error'),
        description: error.message,
        variant: 'destructive',
      });
    },
  });
}
